import {Component, createMemo, createSignal, onCleanup, useContext} from "solid-js";
import {appState} from "../../../../config/app.state";
import {LoadableReady, WalletsModalCloseReason} from "../../../../models";
import {ConnectAdditionalRequest} from "@okxconnect/tonsdk";
import {SingleWalletModal} from "../../../../app/views/modals/wallets-modal/single-wallet-modal";
import {ConnectorContext} from "../../../../config/connector.context";
import {OKXConnectUiContext} from "../../../../config/okx-connect-ui.context";
import {defaultOpenTonUniversalLink, defaultOpenUniversalLink, showTonTgWallet} from "../../../../app/utils/wallets";
import {logDebug,EngineConnectInfo} from "@okxconnect/core";
import { 
  getTonSingleWalletModalIsOpened, 
  getTonSingleWalletModalWalletInfo, 
  lastTonSelectedWalletInfo, 
  setLastTonSelectedWalletInfo 
} from "../../../../app/state/ton-modals-state";

export const TonSingleWalletModal: Component = () => {
  const tonConnectUI = useContext(OKXConnectUiContext)!;
  const connector = useContext(ConnectorContext)!;
  const additionalRequestLoading = (): boolean =>
      appState.connectRequestParameters?.state === "loading";

  const [universalLinkParams, setUniversalLinkParams] = createSignal<EngineConnectInfo | null>(null);

  window.addEventListener("okx-ton-connect-connection-info-before-jump", (event) => {
    const customEvent = event as CustomEvent;
    logDebug("TON   :::",JSON.stringify(customEvent.detail))
    if (customEvent.detail && "connectInfo" in customEvent.detail){
      setUniversalLinkParams(customEvent.detail.connectInfo)
    }
  });

  const additionalRequest = createMemo(() => {
    if (additionalRequestLoading()) {
      return undefined;
    }
    return (
      appState.connectRequestParameters as LoadableReady<ConnectAdditionalRequest>
    )?.value;
  });

  const onClose = (closeReason: WalletsModalCloseReason): void => {
    tonConnectUI.closeModal(closeReason);
  };

  const unsubscribe = connector.onStatusChange((wallet) => {
    if (wallet) {
      onClose("wallet-selected");
    }
  });
  onCleanup(unsubscribe);

  return (
    <SingleWalletModal
      opened={getTonSingleWalletModalIsOpened()}
      walletInfo={getTonSingleWalletModalWalletInfo()}
      loadingBeforeConnect={() => {
        return appState.connectRequestParameters?.state === "loading";
      }}
      connect={() => {
        return new Promise<string>((resolve, reject) => {
          setUniversalLinkParams(null)
          connector.connect({
            openUniversalLink: defaultOpenTonUniversalLink(), // must be same as isSingleWallet
            tonProof: additionalRequest()?.tonProof,
            redirect: appState.returnStrategy,
            tmaReturnUrl:appState.tmaReturnUrl
          }).then((url)=>{
            resolve(url);
          }).catch((error)=>{
            reject(error);
            setUniversalLinkParams(null)
          });
        })
      }}
      onClose={onClose}
      universalLinkParams={universalLinkParams}
      isSingleWallet={!showTonTgWallet()} // must be same as openUniversalLink
      lastSelectedWalletInfo={lastTonSelectedWalletInfo()}
      setLastSelectedWalletInfo={setLastTonSelectedWalletInfo}
    />
  );
};
